/* SUPER DUPER — theme.js  (no dependencies) */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.SD || {};
  var money = function (cents) {
    return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var v = cents / 100;
      if (key === 'amount_no_decimals') return Math.round(v).toLocaleString();
      return v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------- Overlay + panels ---------------- */
  var overlay = $('#overlay');
  var openPanel = null;

  function open(el) {
    if (!el) return;
    close();
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    el.setAttribute('aria-hidden', 'false');
    openPanel = el;
    var f = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 120);
  }
  function close() {
    if (openPanel) {
      openPanel.classList.remove('is-open');
      openPanel.setAttribute('aria-hidden', 'true');
      openPanel = null;
    }
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }
  window.SDClose = close;

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open]');
    if (t) { e.preventDefault(); open($('#' + t.getAttribute('data-open'))); return; }
    if (e.target.closest('[data-close]') || e.target === overlay) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* Focus trap inside open panel */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !openPanel) return;
    var f = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', openPanel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- Mobile nav sub-menus ---------------- */
  $$('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var sub = btn.parentElement.nextElementSibling;
      if (sub) sub.hidden = expanded;
    });
  });

  /* ---------------- Accordions ---------------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.acc__q');
    if (!q) return;
    var expanded = q.getAttribute('aria-expanded') === 'true';
    var panel = q.nextElementSibling;
    q.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.style.maxHeight = expanded ? null : panel.scrollHeight + 'px';
  });

  /* ---------------- Reveal on scroll ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var next = b.getAttribute('data-qty') === 'up' ? val + 1 : Math.max(parseInt(input.min || 1, 10), val - 1);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Rails ---------------- */
  $$('[data-rail-wrap]').forEach(function (wrap) {
    var rail = $('.rail', wrap);
    if (!rail) return;
    var prev = $('[data-rail="prev"]', wrap), next = $('[data-rail="next"]', wrap);
    function step(dir) {
      var first = rail.firstElementChild;
      var w = first ? first.getBoundingClientRect().width + 20 : 300;
      rail.scrollBy({ left: dir * w * Math.max(1, Math.floor(rail.clientWidth / w / 1.5)), behavior: 'smooth' });
    }
    function sync() {
      if (!prev || !next) return;
      prev.disabled = rail.scrollLeft < 6;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 6;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------------- Product gallery ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $('.gallery__slides', g);
    var thumbs = $$('.gallery__thumb', g);
    if (!slides) return;
    function goTo(i) {
      var s = slides.children[i];
      if (s) slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
    }, { passive: true });
    var p = $('[data-gallery-nav="prev"]', g), n = $('[data-gallery-nav="next"]', g);
    if (p) p.addEventListener('click', function () { goTo(Math.max(0, Math.round(slides.scrollLeft / slides.clientWidth) - 1)); });
    if (n) n.addEventListener('click', function () { goTo(Math.min(slides.children.length - 1, Math.round(slides.scrollLeft / slides.clientWidth) + 1)); });
    // Jump to the media of the selected variant
    document.addEventListener('sd:variant', function (e) {
      var id = e.detail && e.detail.variant && e.detail.variant.featured_media && e.detail.variant.featured_media.id;
      if (!id) return;
      var idx = $$('.gallery__slide', g).findIndex(function (s) { return s.dataset.mediaId == id; });
      if (idx > -1) goTo(idx);
    });
  });

  /* ---------------- Variant picker ---------------- */
  $$('[data-variant-picker]').forEach(function (form) {
    var dataEl = $('[data-variant-json]', form);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var idInput = $('[name="id"]', form);
    var btn = $('[data-add-btn]', form);
    var priceEl = $('[data-price]', form);
    var stockEl = $('[data-stock]', form);
    var skuEl = $('[data-sku]', form);

    function selected() {
      return $$('.opt input:checked', form).map(function (i) { return i.value; });
    }
    function find(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var opts = selected();
      var v = find(opts);

      // grey out combinations that do not exist at all
      $$('.variant-group', form).forEach(function (group, gi) {
        $$('.opt input', group).forEach(function (input) {
          var test = opts.slice();
          test[gi] = input.value;
          var match = find(test);
          input.disabled = !match;
        });
        var live = $('[data-opt-value]', group);
        var checked = $('.opt input:checked', group);
        if (live && checked) live.textContent = checked.value;
      });

      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<span class="price__was">' + money(v.compare_at_price) + '</span>';
          html += '<span class="pill pill--sale">Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>';
          priceEl.classList.add('price--on-sale');
        } else { priceEl.classList.remove('price--on-sale'); }
        priceEl.innerHTML = html;
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.dataset.label || 'Add to cart') : 'Sold out';
      }
      if (stockEl) {
        stockEl.className = 'stock' + (!v.available ? ' stock--out' : (v.inventory_quantity !== null && v.inventory_quantity > 0 && v.inventory_quantity <= 5 ? ' stock--low' : ''));
        var txt = !v.available ? 'Out of stock — join the restock list'
          : (v.inventory_quantity !== null && v.inventory_quantity > 0 && v.inventory_quantity <= 5
            ? 'Only ' + v.inventory_quantity + ' left in stock'
            : 'In stock — ships within 24h');
        stockEl.innerHTML = '<span class="stock__dot"></span><span>' + txt + '</span>';
      }
      // keep the URL shareable / analytics-friendly
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('sd:variant', { detail: { variant: v } }));
    }
    form.addEventListener('change', function (e) { if (e.target.closest('.opt')) update(); });
    update();
  });

  /* ---------------- Cart ---------------- */
  var drawer = $('#cart-drawer');

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!drawer) return;
    var body = $('[data-cart-items]', drawer);
    var foot = $('[data-cart-foot]', drawer);
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><h3>Your cart is empty</h3><p class="muted">Grab something before it sells out.</p><a class="btn" href="' + (cfg.routes.all_products || '/collections/all') + '">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var variant = it.options_with_values && it.options_with_values.length && it.variant_title
        ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
      var props = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan.name) || '';
      return '<div class="line-item" data-key="' + it.key + '">' +
        (img ? '<img src="' + img + '" alt="" width="78" height="78" loading="lazy">' : '<div></div>') +
        '<div><a class="line-item__t" href="' + it.url + '">' + it.product_title + '</a>' +
        (variant ? '<div class="line-item__v">' + variant + '</div>' : '') +
        (props ? '<div class="line-item__v">' + props + '</div>' : '') +
        '<div class="qty" style="margin-top:10px;transform:scale(.82);transform-origin:left">' +
        '<button type="button" data-qty="down" aria-label="Decrease">−</button>' +
        '<input type="number" min="0" value="' + it.quantity + '" data-line-qty aria-label="Quantity">' +
        '<button type="button" data-qty="up" aria-label="Increase">+</button></div>' +
        '<button class="line-item__rm" type="button" data-remove>Remove</button></div>' +
        '<div class="line-item__p">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    var totalEl = $('[data-cart-total]', drawer);
    if (totalEl) totalEl.textContent = money(cart.total_price);

    var threshold = (cfg.freeShipping || 0) * 100;
    var bar = $('[data-ship-bar]', drawer);
    if (bar && threshold > 0) {
      bar.hidden = false;
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      $('.ship-bar__fill', bar).style.width = pct + '%';
      $('.ship-bar__t', bar).innerHTML = cart.total_price >= threshold
        ? '🎉 <b>You unlocked free shipping!</b>'
        : 'You are <b>' + money(threshold - cart.total_price) + '</b> away from free shipping';
    } else if (bar) { bar.hidden = true; }
  }

  function fetchCart() {
    return fetch(cfg.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function change(key, quantity) {
    return fetch(cfg.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c);
      if (document.body.classList.contains('template-cart')) window.location.reload();
      return c;
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var li = e.target.closest('.line-item');
      if (!li) return;
      if (e.target.closest('[data-remove]')) { change(li.dataset.key, 0); }
    });
    drawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      var li = e.target.closest('.line-item');
      change(li.dataset.key, parseInt(e.target.value, 10) || 0);
    });
  }

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !cfg.cartDrawer) return;
    e.preventDefault();
    var btn = $('[data-add-btn]', form);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(cfg.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (btn) { btn.textContent = res.data.description || 'Unavailable'; }
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 2200);
          return;
        }
        if (btn) { btn.disabled = false; btn.textContent = label; }
        return fetchCart().then(function () { open(drawer); });
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } form.submit(); });
  });

  if (cfg.cartDrawer && drawer) fetchCart();

  /* ---------------- Predictive search ---------------- */
  var sForm = $('[data-search-form]');
  if (sForm) {
    var input = $('input[name="q"]', sForm);
    var out = $('[data-search-results]');
    var timer, lastQ = '';
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { if (out) out.innerHTML = ''; return; }
      if (q === lastQ) return;
      timer = setTimeout(function () {
        lastQ = q;
        var url = cfg.routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,article,query&resources[limit]=8&section_id=predictive';
        fetch(cfg.routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,article&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = d.resources.results;
            var html = '';
            (res.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
              html += '<a class="search-hit" href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy" width="60" height="60">' : '<div class="search-hit__ph"></div>') +
                '<div><div class="search-hit__t">' + p.title + '</div>' +
                '<div class="search-hit__m">' + (p.vendor ? p.vendor + ' · ' : '') + (p.price ? money(parseFloat(p.price) * 100) : '') + '</div></div></a>';
            });
            (res.collections || []).forEach(function (c) {
              html += '<a class="search-hit" href="' + c.url + '"><div class="search-hit__ph"></div><div><div class="search-hit__t">' + c.title + '</div><div class="search-hit__m">Collection</div></div></a>';
            });
            (res.articles || []).forEach(function (a) {
              html += '<a class="search-hit" href="' + a.url + '"><div class="search-hit__ph"></div><div><div class="search-hit__t">' + a.title + '</div><div class="search-hit__m">Guide</div></div></a>';
            });
            if (!html) html = '<p class="muted" style="padding:12px 4px">No matches for “' + q + '”. Try a brand, a set name or a size.</p>';
            else html += '<a class="btn btn--ghost btn--sm" style="margin-top:14px" href="' + cfg.routes.search_url + '?q=' + encodeURIComponent(q) + '">See all results</a>';
            if (out) out.innerHTML = html;
          })
          .catch(function () { });
      }, 220);
    });
  }

  /* ---------------- Countdown ---------------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var out = $$('[data-cd]', el);
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.classList.add('is-done'); d = 0; }
      var days = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
      var map = { days: days, hours: h, minutes: m, seconds: s };
      out.forEach(function (u) {
        var v = map[u.getAttribute('data-cd')];
        u.textContent = v < 10 ? '0' + v : v;
      });
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------------- Sticky add-to-cart ---------------- */
  var sticky = $('[data-sticky-atc]');
  var anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      sticky.classList.toggle('is-in', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------------- Collection facets ---------------- */
  $$('.facet').forEach(function (f) {
    var btn = $('.facet__btn', f), panel = $('.facet__panel', f);
    if (!btn || !panel) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = panel.classList.contains('is-open');
      $$('.facet__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
      $$('.facet__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) { panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('click', function () {
    $$('.facet__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    $$('.facet__btn[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });
  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', function () { facetForm.submit(); });
  }
  var sortSelect = $('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------------- Header shadow on scroll ---------------- */
  var header = $('.header');
  if (header) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 10);
      last = y;
    }, { passive: true });
  }
})();
